import { fetchManufacturerDevices } from '@gn-audio/core/api/compatibility-guide/fetch-manufacturer-devices';
import { fetchManufacturers } from '@gn-audio/core/api/compatibility-guide/fetch-manufacturers';
import { IManufacturer, IManufacturerDevice } from '@gn-audio/core/api/compatibility-guide/models';
import { Component, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from 'angular-ts-decorators';

import template from './cg-customizer-model-selection.component.html';

interface IOnManufacturerSelectFnArgs {
  manufacturer: IManufacturer;
}

type IOnManufacturerSelectFn = (args: IOnManufacturerSelectFnArgs) => void;

interface IOnModelSelectFnArgs {
  model: IManufacturerDevice;
}

type IOnModelSelectFn = (args: IOnModelSelectFnArgs) => void;

@Component({
  selector: 'cgCustomizerModelSelection',
  template,
})
export class CgCustomizerModelSelectionComponent implements OnInit, OnChanges {
  public static $inject: ReadonlyArray<string> = ['$q'];

  @Input() public selectedManufacturer: IManufacturer;

  @Output() public onManufacturerSelect?: IOnManufacturerSelectFn;
  @Output() public onModelSelect: IOnModelSelectFn;

  public manufacturers?: IManufacturer[];
  public models?: IManufacturerDevice[];
  public selectedModel?: IManufacturerDevice;

  private readonly types: string[] = ['desk_phone', 'dect_phone'];

  constructor(@Inject('$q') private $q: ng.IQService) { }

  public ngOnInit(): void {
    this.$q.when(fetchManufacturers(this.types))
      .then((manufacturers: IManufacturer[]): void => { this.manufacturers = manufacturers; });
  }

  public ngOnChanges(onChangesObject: SimpleChanges<CgCustomizerModelSelectionComponent>): void {
    if (onChangesObject.selectedManufacturer !== undefined && this.selectedManufacturer === null) {
      this.models = [];
      this.selectedModel = null;
    }
  }

  public onManufacturerChanged(): void {
    if (this.onManufacturerSelect) {
      this.onManufacturerSelect({ manufacturer: this.selectedManufacturer });
    }

    if (this.selectedManufacturer === null) {
      this.models = [];
      this.selectedModel = null;
    } else {
      this.$q.when(fetchManufacturerDevices(this.selectedManufacturer.id, this.types))
        .then((models: IManufacturerDevice[]): void => { this.models = models; });
    }
  }

  public onModelChanged(): void {
    if (!this.onModelSelect) {
      return;
    }

    this.onModelSelect({ model: this.selectedModel });
  }
}
